import React from 'react';
import {StyleSheet, View} from 'react-native';
import Text from '@/components/basic/text';
import theme from '@/style';
import CarNumber from './car-number';

export interface CarItemProps {
  cars: string;
  roundNum: string;
}

const CarItem = ({roundNum = '', cars = ''}: CarItemProps) => {
  return (
    <View style={[theme.flex.row, theme.flex.centerByCol, styles.row]}>
      <View style={[theme.flex.flex1, styles.left]}>
        <Text style={styles.roundNum}>{roundNum}</Text>
      </View>
      <View style={[theme.flex.row, theme.flex.centerByCol, styles.right]}>
        {cars
          .split(',')
          .filter(Boolean)
          .map((item, _i) => (
            <CarNumber
              key={_i}
              num={+item}
              type="square"
              squareSize={16}
              textSize={+item > 9 ? 9 : 10}
            />
          ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    minHeight: 40,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: '#EFF1F5',
  },
  left: {
    paddingHorizontal: 12,
    justifyContent: 'center',
  },
  right: {
    paddingHorizontal: 12,
    gap: 2,
    justifyContent: 'flex-end',
  },
  roundNum: {
    color: '#4E5665',
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '500',
  },
});

export default CarItem;
